export const translations = {
  en: {
    //NAV
    nav_home: "Home",
    nav_about: "About",
    nav_agenda: "Agenda",
    nav_projects: "Projects",
    nav_medias: "Medias",
    nav_contact: "Contact",
    nav_legal_notices: "Legal Notices",
    nav_privacy_policy: "Privacy Policy",
    nav_navigation: "Navigation",
    nav_socials: "Socials",
    nav_related_links: "Related Links" ,

    learn_more: "Learn more",
    //HOME
    sentence1: "Through",
    upcoming_concerts: "Upcoming concerts",

    //ABOUT

    //AGENDA
    past_concerts: "Past concerts",

    //PROJECTS

    //MEDIAS
    photos: "Photos",
    portfolio_desc: "Shooting, performances, collaborations & artistic moments.",
    performances: "Videos",
    performances_desc: "A selection of videos from various artistic projects.",

    //CONTACT
    mail: "mail :",

    //FOOTER
    allrightsreserved: "All rights reserved"

  },
  fr: {
    //NAV
    nav_home: "Home",
    nav_about: "À propos",
    nav_agenda: "Agenda",
    nav_projects: "Projets",
    nav_medias: "Médias",
    nav_contact: "Contact",
    nav_legal_notices: "Mentions légales",
    nav_privacy_policy: "Politiques de confidentialité",
    nav_navigation: "Navigation",
    nav_socials: "Réseaux",
    nav_related_links: "Liens utiles" ,
    
    learn_more: "En savoir plus",
    //HOME
    sentence1: "À travers",
    upcoming_concerts: "Concerts à venir",

    //ABOUT

    //AGENDA
    past_concerts: "Concerts passés",

    //PROJECTS

    //MEDIAS
    photos: "Photos",
    portfolio_desc: "Shooting, performances, collaborations et moments artistiques.",
    performances: "Vidéos",
    performances_desc: "Une selection de vidéos pour différents projets artistiques.",

    //CONTACT
    mail: "e-mail :",

    //FOOTER
    allrightsreserved: "Tous droits réservés"

  },
};